import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=4937f968&scoped=true&"
import script from "./taskInfo.vue?vue&type=script&lang=js&"
export * from "./taskInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=4937f968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937f968",
  null
  
)

export default component.exports